export default "I am 1-column post. \"{{ element.value }}\" ";